import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-ib-header',
  templateUrl: './ib-header.component.html',
  standalone: false,
})
export class IbHeaderComponent {
  @Input() active = 'Shows'
  menuOpen = false

  toggleMenu() {
    this.menuOpen = !this.menuOpen
  }
}
